import { isEqual } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Tree } from '~/eds/src/components/Tree/Tree';
import { TreeNode } from '~/eds/src/types/TreeNode';
import { slices } from '~/redux/slices';
import { sortByStringValue } from '~/utils/array';

import { ModelCard } from './ModelCard';

export const ModelCart = () => {
  const cartModels = useSelector(slices.xRayLibrary.selectors.selectCart);

  const categoryModels = useSelector(
    slices.xRayLibrary.selectors.selectCategoryModels,
  );

  const [tree, setTree] = useState<TreeNode[]>([]);

  useEffect(() => {
    const initialTree: TreeNode[] = [];
    categoryModels.forEach((models, label) => {
      initialTree.push({
        children: models.sort(sortByStringValue('label')).map((model) => ({
          key: model.libraryModelId,
          content: <ModelCard model={model} size="xs" />,
          name: model.label,
          parentKey: label,
          children: [],
          options: { disableHover: true },
          padding: '8px 24px 8px 48px',
        })),
        key: label,
        name: label,
        isExpanded: tree.find((node) => node.key === label)?.isExpanded ?? true,
      });
    });
    setTree(initialTree);
  }, [cartModels]);

  return (
    <Tree
      name="model-library-shopping-cart-tree"
      tree={tree}
      totalCount={cartModels.length}
      onUpdate={(updatedTree) => {
        if (!isEqual(updatedTree, tree)) {
          setTree(updatedTree);
        }
      }}
    />
  );
};
